import { AuditCard } from "@/features/Audit/AuditCard";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { Button, Link } from "@heroui/react";
import { IssuersEditCard } from "./edit_card";

const client = "instit-quantilia";
const table_name = "issuers";

export const IssuersCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <div className="flex">
          <div className="flex-grow flex justify-center">
            <IssuersEditCard
              id={Number(id)}
              client={client}
              table_name={table_name}
            />
          </div>
          <div className="flex flex-col gap-2">
            <Button
              href={toWorkspacePath(
                `/admin/qtl - referential/strategies?issuer_id_equals=${id}`,
              )}
              variant="bordered"
              color="primary"
              showAnchorIcon
              as={Link}
              radius="full"
              className="bg-white border-1 border-neutral-300 shadow-xl"
            >
              Strategies
            </Button>
          </div>
        </div>
        <AuditCard
          id={Number(id)}
          client={client}
          audit_table_name={table_name}
        />
      </div>
    </div>
  );
};
